import {
  BAR_WIDTH,
  BAR_GAP,
} from 'services/hooks/waveform/useSharedWaveformStyle';

const STEP = BAR_GAP + BAR_WIDTH;

const getAbsoluteMaxValue = (values: Float32Array | number[]) => {
  let currentMax = -1;
  values.forEach((value) => {
    currentMax = Math.max(currentMax, Math.abs(value));
  });

  return currentMax;
};

export const renderFunction = (
  peaksData: (Float32Array | number[])[],
  ctx: CanvasRenderingContext2D
) => {
  const { width, height } = ctx.canvas;

  const peaks = peaksData[0];
  const scale = peaks.length / width;
  const halfHeight = height / 2;

  const absMax = getAbsoluteMaxValue(peaks);

  for (let i = 0; i < width; i += STEP) {
    const barHeight =
      Math.round((peaks[Math.floor(i * scale)] / absMax) * halfHeight) || 1;
    ctx.fillRect(i, halfHeight - barHeight, BAR_WIDTH, barHeight * 2);
  }
};
